import { Container } from '@mui/material';
import { type FC } from 'react';

import useMarkdownFile from '../../hooks/useMarkdownFile';
import aboutUs from '../../markdowns/aboutUs.md';

const AboutUs: FC = () => {
  const { markdownContent } = useMarkdownFile(aboutUs);

  return <Container maxWidth='md'>{markdownContent}</Container>;
};

export default AboutUs;
